<template>
  <section class="section columns is-multiline pb-0">
    <div class="column is-half is-offset-one-quarter box p-5">
      <div class="is-flex is-align-items-center mb-4">
        <img src="@/assets/placeholder.svg" width="50" height="50" alt="Logo" />
        <img src="@/assets/logo-text.png" width="170" height="18" alt="Logo" />
      </div>
      <div class="content">
        <p>
          Esta aplicação foi desenvolvida com o objetivo de mapear a propagação
          de doenças de forma colaborativa, mostrando em tempo real o
          quantitativo de pessoas que indicaram que estão com a doença, que
          estão recuperadas, e que já foram vacinadas. Você também pode compartilhar
          uma mensagem oferecendo ou pedindo ajuda, que será vista por todos os
          usuários. Desse modo criamos uma rede social de socorro humanitário
          que dependerá também de sua ajuda para ter grande alcance e
          abrangência. O preenchimento é simples e muito
          rápido!
        </p>
        <p>
          Leia os nossos
          <router-link :to="{ name: 'terms' }" target="_blank">
            Termos de uso
          </router-link>
        </p>
      </div>
      <div class="buttons is-right">
        <b-button
          tag="router-link"
          :to="{ name: 'login' }"
          type="is-link"
          rounded
        >
          Login
        </b-button>
        <b-button
          tag="router-link"
          :to="{ name: 'register' }"
          type="is-link"
          rounded
        >
          Cadastre-se
        </b-button>
      </div>
      <div class="is-size-7">
        <div>
          Ícones feitos por
          <template v-for="(criador, idx) in criadoresIcones">
            <a
              class="icon-creator-link"
              :key="criador.name"
              :href="criador.url"
              :title="criador.title"
            >
              {{ criador.name }}
            </a>
            {{ (criadoresIcones.length - 1 > idx && ",") || "em" }}
          </template>
          <a href="https://www.flaticon.com/" title="Flaticon">
            www.flaticon.com
          </a>
        </div>
      </div>
      <hr />
      <talk-to-us />
    </div>
  </section>
</template>
<script>
import TalkToUs from '@/components/UI/TalkToUs.vue';
import { criadoresIcones } from '@/data/criadoresIcones';
import { constantsMixin } from '@/mixins/constants';

export default {
  components: { TalkToUs },
  name: 'home',
  mixins: [constantsMixin({ criadoresIcones })],
};
</script>
